import http, { API_CORE } from '../../http';

export default function AiServiceV2() {
  const translateContent = async (data) => {
    const response = await http(API_CORE).post('/v2/ai/translate', { data });
    return response.data;
  };

  return { translateContent };
}
